module.exports = __webpack_public_path__ + "static/media/anhthu_do.2d0da17d.png";